import { getDistinctFilteredForms } from "js/formatting/getDistinctFilteredForms";
import { getAgentFormsByPolicy } from "service/forms/getAgentFormsByPolicy";
import { useRowPagination } from "hooks/useRowPagination";
import {
  getProductLineByPolicyType,
  isCSR as isCSRRole,
  isCSRAdmin as isCSRAdminRole,
} from "js/utilities";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useState, useEffect, useContext } from "react";
import { getCompanyNameByBlockCode } from "js/formatting";
import { useSelector } from "react-redux";
import { isCSR, isCSRAdmin } from "js/utilities";

import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import PillWithActionButton from "components/General/PillWithActionButton";
import AgentAutoCompleteComboBox from "components/General/AutoCompleteComboBox/AgentAutoCompleteComboBox";
import SimpleDataRow from "components/General/SimpleDataRow";
import RowPagination from "components/General/RowPagination";
import FormInputError from "components/General/FormInputError";
import InputWithActionButton from "components/General/InputWithActionButton";
import { AgentData } from "context/Agent/DataProvider";
import { Dialog } from "@headlessui/react";
import DialogBackdrop from "components/ModalDialogs/DialogBackdrop";
import { sendEmailNotification_v2 } from "service/notificationservice/sendEmailNotification";

export default function SearchByPolicyPanel({
  selectedPolicyId,
  setSelectedPolicyId,
  selectedCatagory,
  setSelectedCatagory,
  searchByKeyWords,
  setSearchByKeyWords,
  isClearClicked,
}) {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.user);
  const { csrUser } = useSelector((state) => state.csrUser);
  const { agentPolicies } = useContext(AgentData);

  //Declare UseState
  const {
    handleSubmit,
    reset,
    control,
    clearErrors,
    formState: { errors },
  } = useForm();

  const [allSelectedByPolicyForms, setAllSelectedByPolicyForms] = useState([]);
  const [searchbyPolicyForms, setSearchbyPolicyForms] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [policyFilterOptions, setPolicyFilterOptions] = useState([]);
  const [catagories, setCatagories] = useState([]);
  const [productLine, setProductLine] = useState();
  const [state, setState] = useState();
  const [company, setCompany] = useState();
  ////////////////////////////////////////////////////////////////
  const [isSendEmailDialogOpen, setIsSendEmailDialogOpen] = useState(false);
  const [recipientEmail, setRecipientEmail] = useState("");
  const [sendEmailError, setSendEmailError] = useState("");
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [sendEmailSuccessMessage, setSendEmailSuccessMessage] = useState("");
  const [selectedFormId, setSelectedFormId] = useState(null);
  const isCSRUser = isCSRRole(csrUser) || isCSRAdminRole(csrUser);

  // getting policy number with primary owner full name
  useEffect(() => {
    if (agentPolicies.length > 0) {
      setIsLoading(true);
      let policySelectionArray = [];
      agentPolicies?.map((policy) => {
        policySelectionArray.push({
          value: policy?.oldPolicy,
          displayAs: `${policy?.oldPolicy}: ${policy?.insuredFullName}`,
          displayAsValue: `${policy?.oldPolicy}`,
          ...policy,
        });
      });
      if (policySelectionArray?.length > 0)
        setPolicyFilterOptions([
          {
            value: "all",
            displayAs: "Select Contract",
            displayAsValue: "Select Contract",
          },
          ...policySelectionArray,
        ]);
      setIsLoading(false);
    }
  }, [agentPolicies]);
  /////////////////////////////////////////////////////

  // Methods

  const filterByKeyWords = (form, keywords) => {
    let formFound;
    keywords.forEach((keyWord) => {
      let splitKeyWords = keyWord.split(/\s+/g);
      splitKeyWords.forEach((sk) => {
        if (form.keywords.toLowerCase().includes(sk.toLowerCase()))
          formFound = form;
      });
    });
    return formFound;
  };
  const filteredForms = (forms, categoryId, keywords) => {
    if (
      selectedPolicyId !== "all" &&
      selectedPolicyId.value !== "all" &&
      forms?.length > 0
    ) {
      let filteredSelectedByPolicyForms = [...forms];

      if (filteredSelectedByPolicyForms?.length > 0) {
        if (categoryId && categoryId !== "all") {
          filteredSelectedByPolicyForms = filteredSelectedByPolicyForms.filter(
            (form) => parseInt(form.categoryId) === parseInt(categoryId)
          );
        }
        if (keywords?.length > 0 && filteredSelectedByPolicyForms?.length > 0) {
          filteredSelectedByPolicyForms = filteredSelectedByPolicyForms.filter(
            (form) => {
              let formFound = filterByKeyWords(form, keywords);
              if (formFound) return formFound;
            }
          );
        }
      }
      setSearchbyPolicyForms(
        getDistinctFilteredForms(filteredSelectedByPolicyForms)
      );
    }
  };
  const onSubmit = (data, e) => {
    let keyword = data?.keyword?.trim();
    if (keyword) {
      if (!searchByKeyWords.includes(keyword))
        setSearchByKeyWords((current) => [...current, keyword]);
      e.target.reset();
    }
  };

  function removeSearchKeyWord(search, value) {
    var index = search.indexOf(value);
    if (index > -1) {
      search.splice(index, 1);
    }
    return search;
  }
  const removeKeyWord = (search) => {
    let value = removeSearchKeyWord(searchByKeyWords, search);
    if (value?.length > 0) setSearchByKeyWords((curr) => [...curr]);
    else setSearchByKeyWords([]);
    reset();
    document.getElementById("Site Search").value = "";
  };
  //////////////////////////////////////////////////////////////////////

  // GetForm API call
  async function getForm(policyNumber) {
    if (policyNumber && policyNumber !== "all") {
      setIsLoading(true);
      await getAgentFormsByPolicy(policyNumber, user?.agentViewingId)
        .then((respone) => {
          if (respone.form?.length > 0) {
            setSearchbyPolicyForms(respone.form);
            setAllSelectedByPolicyForms(respone.form);
            setCatagories([
              ...new Map(
                respone.form.map((form) => [form["categoryId"], form])
              ).values(),
            ]);
            filteredForms(respone.form, selectedCatagory, searchByKeyWords);
          } else {
            clearSearchbyPolicyForms();
          }
          if (respone?.policyDetail) {
            setProductLine(
              getProductLineByPolicyType(respone?.policyDetail?.productType)
            );
            setCompany(
              getCompanyNameByBlockCode(respone?.policyDetail?.company)
            );
            setState(respone?.policyDetail?.issueState);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.error("Error", error);
        });
    } else {
      clearSearchbyPolicyForms();
      setProductLine(undefined);
    }
  }

  const clearSearchbyPolicyForms = () => {
    setSearchbyPolicyForms([]);
    setCatagories([]);
    setAllSelectedByPolicyForms([]);
  };
  /////////////////////////////////////////

  useEffect(() => {
    clearSearchbyPolicyForms();
    setProductLine(undefined);
  }, [isClearClicked]);

  useEffect(() => {
    filteredForms(allSelectedByPolicyForms, selectedCatagory, searchByKeyWords);
    clearErrors();
  }, [selectedCatagory, searchByKeyWords]);

  useEffect(() => {
    if (selectedPolicyId !== "all") {
      setSelectedCatagory("all");
      setSearchByKeyWords([]);
      getForm(selectedPolicyId?.value);
      setSelectedCatagory(selectedCatagory);
      setSearchByKeyWords(searchByKeyWords);
    }
    clearErrors();
  }, [selectedPolicyId]);

  ////////////////

  const {
    rowsForDisplay: searchbyPolicyFormsRows,
    rowPaginationProps: searchbyPolicyFormsPaginationProps,
  } = useRowPagination(searchbyPolicyForms);

  return (
    <>
      <EverlakeLoadingOverlay
        isLoading={isLoading}
        loadingText="Please wait while we retrieve forms... "
      >
        <div className="p-2 md:p-4 bg-white rounded-b-lg shadow-[2px_4px_4px_0_rgba(0,0,0,0.16)]">
          <div className="grid gap-2 md:gap-x-4 md:grid-cols-[2fr,1fr,1.5fr]">
            <AgentAutoCompleteComboBox
              labelName="Contract Search"
              inputPlaceholderText={"Select Contract"}
              options={policyFilterOptions}
              invalidMessage={t("AlertsCorrespondence-input-invalid-msg-1")}
              selectedOption={selectedPolicyId}
              setSelectedOption={setSelectedPolicyId}
            />

            {!isLoading &&
              selectedPolicyId !== "all" &&
              selectedPolicyId.value !== "all" && (
                <>
                  <div className="mt-1">
                    {catagories?.length > 0 && (
                      <>
                        <div className="flex items-center mb-1">
                          <label htmlFor="categoryId">
                            {t(
                              "AgentSearchByDocumentForms-search-contact-category"
                            )}
                          </label>
                        </div>
                        <div>
                          <select
                            id="categoryId"
                            className="w-full"
                            defaultValue={selectedCatagory}
                            onChange={(e) => {
                              setSelectedCatagory(e.target.value);
                            }}
                          >
                            <option value="all">All</option>
                            {catagories?.length > 0 && (
                              <>
                                {catagories.map((c) => (
                                  <option
                                    key={`forms - ${c.categoryId}`}
                                    value={c.categoryId}
                                  >
                                    {c.category}
                                  </option>
                                ))}
                              </>
                            )}
                          </select>
                        </div>
                      </>
                    )}
                  </div>
                  <form
                    onSubmit={handleSubmit(onSubmit)}
                    className="flex flex-col-reverse"
                  >
                    {catagories?.length > 0 && (
                      <Controller
                        name="keyword"
                        control={control}
                        render={({ field: { onChange } }) => (
                          <InputWithActionButton
                            labelName="Keyword"
                            buttonType="submit"
                            buttonLabel={t(
                              "AgentSearchByDocumentForms-search-button"
                            )}
                            ariaLabel={t(
                              "AgentSearchByDocumentForms-search-aria-label"
                            )}
                            placeholder={t(
                              "AgentSearchByDocumentForms-search-placeholder"
                            )}
                            error={t(
                              "AgentSearchByDocumentForms-search-error-message"
                            )}
                            onChange={onChange}
                          />
                        )}
                        rules={{
                          pattern: {
                            value: /^[A-Za-z0-9() \-]+$/,
                            message:
                              "Keyword cannot contain any special characters (@,*,&, etc.).",
                          },
                          required: "Please enter keyword to search",
                        }}
                      />
                    )}
                  </form>
                  {errors?.keyword?.message && (
                    <>
                      <div></div>
                      <div></div>
                      <FormInputError errorMessage={errors?.keyword?.message} />
                    </>
                  )}
                </>
              )}
          </div>
          {productLine && state && company && (
            <div className="mt-2 flex flex-start gap-4">
              <h3 className="text-sm">
                Product Line:{" "}
                <span className="font-semibold">{productLine}</span>
              </h3>
              <h3 className="text-sm">
                State: <span className="font-semibold">{state}</span>
              </h3>
              <h3 className="text-sm">
                Company:{" "}
                <span className="font-semibold">
                  {getCompanyNameByBlockCode(company)}
                </span>
              </h3>
            </div>
          )}
          {searchByKeyWords &&
            !isLoading &&
            selectedPolicyId !== "all" &&
            selectedPolicyId.value !== "all" && (
              <div className="mt-2 flex flex-start gap-2 ">
                {searchByKeyWords.map((search, idx) => (
                  <PillWithActionButton
                    key={`search for forms - ${idx}`}
                    label={search}
                    action={() => removeKeyWord(search)}
                  />
                ))}
              </div>
            )}
        </div>
        {searchbyPolicyFormsRows?.length > 0 ? (
          <>
            <p className="mt-4 mb-2">
              <span className="font-semibold"> HIV:</span> Select the form(s)
              with the state that matches each insured's lab testing location.
            </p>
            {searchbyPolicyFormsRows?.map((form, idx) => (
              <SimpleDataRow
                key={`forms - ${idx}`}
                data={form}
                type="form"
                formSearchType={"Policy Search"}
                hideFormSubTitle={true}
                isCSRUser={isCSRUser}
                onSendEmailClick={(row) => {
                  setRecipientEmail("");
                  setSendEmailSuccessMessage("");
                  setSendEmailError("");
                  setSelectedFormId(Number(row?.id));
                  setIsSendEmailDialogOpen(true);
                }}
              />
            ))}
            <RowPagination {...searchbyPolicyFormsPaginationProps} />
          </>
        ) : (
          <div className="w-full mt-4 mb-2 md:ml-6 text-center">
            {!isLoading && (
              <>
                {!selectedPolicyId ||
                selectedPolicyId === "all" ||
                selectedPolicyId.value === "all" ? (
                  <h3> {t("AgentForms-errormessage")}</h3>
                ) : (
                  <h3>{t("AgentForms-displayMessage")}</h3>
                )}
              </>
            )}
          </div>
        )}
      </EverlakeLoadingOverlay>
      <Dialog
        open={isCSRUser && isSendEmailDialogOpen}
        onClose={() => {
          setIsSendEmailDialogOpen(false);
          setRecipientEmail("");
          setSendEmailError("");
          setSendEmailSuccessMessage("");
          setSelectedFormId(null);
        }}
        className="ui-dialogs"
      >
        <DialogBackdrop />
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel
            role="dialog"
            aria-modal="true"
            className="ui-default-dialog max-w-md w-full"
          >
            <Dialog.Title className="font-body text-xl font-bold text-left">
              Send Email
            </Dialog.Title>
            <button
              className="ui-default-dialog-close"
              aria-label="close send email dialog"
              onClick={() => {
                setIsSendEmailDialogOpen(false);
                setRecipientEmail("");
                setSendEmailError("");
                setSendEmailSuccessMessage("");
                setSelectedFormId(null);
              }}
            >
              <svg
                className="ui-icon h-3.5 w-3.5"
                focusable="false"
                aria-hidden="true"
                role="presentation"
              >
                <use href="#ui-icon-close"></use>
              </svg>
            </button>
            <hr />
            <div className="ui-dialog-body">
              <label
                id="send_email_input_label"
                htmlFor="send_email_input"
                className="block mb-2"
              >
                Recipient Email Address
              </label>
              <input
                id="send_email_input"
                type="email"
                aria-labelledby="send_email_input_label"
                className="mt-1"
                value={recipientEmail}
                onChange={(e) => {
                  setRecipientEmail(e.target.value);
                  setSendEmailError("");
                  setSendEmailSuccessMessage("");
                }}
                disabled={isSendingEmail}
              />
              {sendEmailError ? (
                <FormInputError errorMessage={sendEmailError} />
              ) : null}
              {sendEmailSuccessMessage ? (
                <p className="mt-2 text-green-700">{sendEmailSuccessMessage}</p>
              ) : null}
            </div>
            <div className="block text-right mt-6">
              <button
                type="button"
                className="ui-btn-secondary ui-btn-min-w mt-4"
                onClick={() => {
                  setIsSendEmailDialogOpen(false);
                  setRecipientEmail("");
                  setSendEmailError("");
                  setSendEmailSuccessMessage("");
                  setSelectedFormId(null);
                }}
                disabled={isSendingEmail}
              >
                Cancel
              </button>
              <button
                type="button"
                className="ui-btn-primary ui-btn-min-w mt-4 ml-2"
                onClick={async () => {
                  const trimmedEmail = recipientEmail.trim();
                  const emailPattern = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

                  if (!trimmedEmail) {
                    setSendEmailError("Email is required.");
                    return;
                  }
                  if (!emailPattern.test(trimmedEmail)) {
                    setSendEmailError("Please enter a valid email address.");
                    return;
                  }
                  setIsSendingEmail(true);
                  setSendEmailError("");
                  setSendEmailSuccessMessage("");
                  try {
                    await sendEmailNotification_v2(
                      trimmedEmail,
                      selectedFormId
                    );
                    setSendEmailSuccessMessage("Email sent successfully.");
                    setRecipientEmail("");
                  } catch (error) {
                    setSendEmailError("Failed to send email.");
                  } finally {
                    setIsSendingEmail(false);
                  }
                }}
                disabled={isSendingEmail}
              >
                {isSendingEmail ? "Sending..." : "Send"}
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
}
